export const FETCH_ALL_FIELDS_TABLE_BEGIN= 'FETCH_ALL_FIELDS_TABLE_BEGIN';
export const FETCH_ALL_FIELDS_TABLE_SUCCESS='FETCH_ALL_FIELDS_TABLE_SUCCESS';
export const FETCH_ALL_FIELDS_TABLE_ERROR='FETCH_ALL_FIELDS_TABLE_ERROR';
export const ADD_FIELD_TABLE_SUCCESS='FETCH_ADD_FIELD_TABLE_SUCCESS';
export const ADDED_MAP_OF_FIELD='ADDED_MAP_OF_FIELD';
export const SET_CURRENT='SET_CURRENT';

